<template>
  <section class="update-info-form">
    <div class="tip" style="margin:0 0 0 20px">
      <p>* 项目基本资料</p>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目编号">
          <el-input size="small" :disabled="true" placeholder="请输入项目编号" v-model="project.number"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="项目需求单位">
      <el-input size="small" :disabled="true" v-model="project.deptName"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目名称">
          <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="项目负责人">
          <el-input size="small" :disabled="true" v-model="project.leader.name"></el-input>
        </el-form-item>
      </el-col>
    </div>


    <div class="clear">
      <el-col :span="12" v-for="item,i in formTimeArr" :key="i">
        <el-form-item :class="item.type=='important'?'important-label':''" :label="item.title" label-width="210px">
          <el-date-picker size="small" id="data_picker_0"
            value-format="yyyy-MM-dd" v-model="formRadio[item.key][1]" type="date" placeholder="选择时间">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </div>

    <el-form-item label="备注">
      <el-input type="textarea" placeholder="请填写修改原因" v-model="form.remark" :autosize="{ minRows: 4, maxRows: 6}"
        size="small"></el-input>
    </el-form-item>

  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData'],
    data() {
      return {
        form: {},
        formTimeArr: [{
          title: "*项目立项计划完成时间",
          key: "lxUptime",
          type: "important"
        }, {
          title: "*施工招标计划完成时间",
          key: "sgzbwcsj",
          type: "important"
        }, {
          title: "*项目计划开工时间",
          key: "jhkgsj",
          type: "important"
        }, {
          title: "*项目计划施工完成时间",
          key: "jhwgsj",
          type: "important"
        }],
        formRadio: {},
        oldFormRadio: '',
      }
    },
    created() {
      for (var i = 0; i < this.formTimeArr.length; i++) {
        this.$set(this.formRadio, this.formTimeArr[i].key, ["", ""])
      }
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      getFromData() {
        for (var key in this.formRadio) {
          this.form[key] = this.formRadio[key][0] ? this.formRadio[key][0] : this.formRadio[key][1]
        }
        console.log(this.form)
        return this.form
      },
      foreachFormRadioArr() {
        if (this.oldFormRadio) {
          this.oldFormRadio = JSON.parse(this.oldFormRadio)
        }
        for (var key in this.formRadio) {
          if (this.oldFormRadio) {
            if (this.formRadio[key][1] != this.oldFormRadio[key][1]) {
              this.formRadio[key][0] = ""
            } else if (this.formRadio[key][0] != this.oldFormRadio[key][0]) {
              this.formRadio[key][1] = ""
            }
          }
        }
        this.oldFormRadio = JSON.stringify(this.formRadio)
      },
    },
    watch: {
      formRadio: {
        handler() {
          this.foreachFormRadioArr()
        },
        deep: true,
      },
      form: {
        handler(newName, oldName) {
          for (var i = 0; i < this.formTimeArr.length; i++) {
            var item = this.formTimeArr[i]
            if (this.form[item.key]) {
              if (this.form[item.key] == -1 || this.form[item.key] == -2) {
                console.log(this.form[item.key])
                this.$set(this.formRadio, this.formTimeArr[i].key, [this.form[item.key], ""])
              } else {
                console.log(this.form[item.key])
                this.$set(this.formRadio, this.formTimeArr[i].key, ["", this.form[item.key]])
              }
            }
          }
        },
        deep: true,
      },
      formByFather() {
        this.form = this.formByFather

      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createUpdateTime.vue